/** vapor-chamber-router — injection keys. */

export const ROUTER_KEY = Symbol.for('vapor-chamber-router');
export const OUTLET_DEPTH_KEY = Symbol.for('vapor-chamber-router:depth');
